import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";

export const getProjectList = async () => {
  const res = await fetchApi.get(API_URL.PROJECT_LiST);
  return res.data;
}
export const getProject = async (id) => {
  const res = await fetchApi.get(API_URL.GET_PROJECT.replace("{id}", id));
  return res.data;
}
export const postProject = async (project) => {
  const res = await fetchApi.post(API_URL.POST_PROJECT, project);
  return res.data;
}
export const postNameProject = async (id, name) => {
  const res = await fetchApi.post(API_URL.SAVE_NAME_PROJECT.replace("{id}", id), {
    name: name
  });
  return res.data;
}
export const postDuplicateProject = async (id) => {
  const res = await fetchApi.post(API_URL.SAVE_DUPLICATE_PROJECT.replace("{id}", id));
  return res.data;
}
export const turnProject = async (id, turn) => {
  const res = await fetchApi.post(API_URL.TURN_PROJECT, {
    id: id,
    turn: turn
  });
  return res.data;
}
export const getDetailProject = async (id) => {
  const res = await fetchApi.get(API_URL.DETAIL_PROJECT.replace("{id}", id));
  return res.data;
}
export const getDetailEventsToProject = async (id) => {
  const res = await fetchApi.get(API_URL.DETAIL_EVENTS_PROJECT.replace("{id}", id));
  return res.data;
}
export const getEntryPointsToProject = async (id) => {
  const res = await fetchApi.get(API_URL.ENTRY_POINTS_PROJECT.replace("{id}", id));
  return res.data;
}
export const getDetailBenefitQuantities = async (id) => {
  const res = await fetchApi.get(API_URL.DETAIL_BENEFIT_QUANTITY_PROJECT.replace("{id}", id));
  return res.data;
}
export const getDetailBenefitStatistics = async (id) => {
  const res = await fetchApi.get(API_URL.DETAIL_BENEFIT_STATISTICS_PROJECT.replace("{id}", id));
  return res.data;
}
// 확률 변경 구간별 발급 현황 (2026-07-29 추가)
// NOTE: 경로를 constants/axios.js 의 API_URL 이 아니라 여기에 둔 이유 —
//       axios.js 에는 미배포 A2(정산) 상수가 미커밋으로 섞여 있어, 상수를 추가하면 이 기능만 단독 배포할 수 없다.
//       A2 배포 이후 API_URL 로 옮길 것. 배경 = _handover/11_RISK_REGISTER.md §L(RP-00)
const DETAIL_BENEFIT_PROBABILITY_SEGMENTS_PROJECT = '/project/{id}/detail/benefit/probability-segments';
export const getDetailBenefitProbabilitySegments = async (id) => {
  const res = await fetchApi.get(DETAIL_BENEFIT_PROBABILITY_SEGMENTS_PROJECT.replace("{id}", id));
  return res.data;
}
export const getDetailDuplicateProjects = async (id) => {
  const res = await fetchApi.get(API_URL.DETAIL_DUPLICATES_PROJECT.replace("{id}", id));
  return res.data;
}
export const postProjectEvent = async (projectId, eventId) => {
  const res = await fetchApi.post(API_URL.EVENT_PROJECT, {
    projectId: projectId,
    eventId: eventId
  });
  return res.data;
}
export const deleteProjectEvent = async (projectId, eventId) => {
  const res = await fetchApi.post(API_URL.EVENT_DELETE_PROJECT, {
    projectId: projectId,
    eventId: eventId
  });
  return res.data;
}
export const postProjectEntryPoint = async (projectId, eventId, entryPointIds) => {
  const res = await fetchApi.post(API_URL.ENTRYPOINT_PROJECT, {
    projectId: projectId,
    eventId: eventId,
    entryPointIds: entryPointIds
  });
  return res.data;
}
export const postProjectPassword = async (id, password, type) => {
  const res = await fetchApi.post(API_URL.PASSWORD_PROJECT, {
    id: id,
    type: type,
    benefitPassword: password
  });
  return res.data;
}
export const postProjectPeriod = async (id, startDate, endDate) => {
  const res = await fetchApi.post(API_URL.PERIOD_PROJECT, {
    id: id,
    startDate: startDate,
    endDate: endDate
  });
  return res.data;
}
export const postProjectDuplicates = async (id, duplicateProjects) => {
  const res = await fetchApi.post(API_URL.DUPLICATES_PROJECT, {
    id: id,
    duplicateProjects: duplicateProjects
  });
  return res.data;
}
export const postProjectBenefitQuantities = async (id, quantityType, defaultBenefitSettings, benefitQuantitySettings) => {
  const res = await fetchApi.post(API_URL.DETAIL_BENEFIT_QUANTITY_PROJECT.replace("{id}", id), {
    id: id,
    quantityType: quantityType,
    defaultBenefitSettings: defaultBenefitSettings,
    benefitQuantitySettings: benefitQuantitySettings
  });
  return res.data;
}
export const postProjectUnUsedBenefitQuantity = async (id) => {
  const res = await fetchApi.post(API_URL.DETAIL_UN_USED_BENEFIT_QUANTITY_PROJECT.replace("{id}", id), {
    id: id
  });
  return res.data;
}
export const deleteProjectDuplicate = async (id, duplicateProject) => {
  const res = await fetchApi.post(API_URL.DUPLICATE_DELETE_PROJECT, {
    id: id,
    duplicateProject: duplicateProject
  });
  return res.data;
}
/**
 * 진입점별 점유 현황. `{ [spotId]: [{projectId, projectName, period, scheduled}] }`
 * 🔴 `excludeProjectId` 를 반드시 넘긴다 — 지금 편집 중인 프로젝트가 자기 진입점을
 *    "다른 프로젝트가 점유 중" 으로 표시하면 안 된다.
 */
export const getEntryPointOccupancy = async (excludeProjectId) => {
  const res = await fetchApi.get(
      `${API_URL.ENTRYPOINT_OCCUPANCY}${excludeProjectId != null ? `?excludeProjectId=${excludeProjectId}` : ""}`);
  return res.data;
}
export const deleteProjectEntryPoint = async (projectId, eventId, entryPointId) => {
  const res = await fetchApi.post(API_URL.ENTRYPOINT_DELETE_PROJECT, {
    projectId: projectId,
    eventId: eventId,
    entryPointId: entryPointId
  });
  return res.data;
}

export const getProjectPrizeUsers = async (projectId, benefitId, userName, page, size) => {
  const res = await fetchApi.get(`${API_URL.PRIZE_USERS_PROJECT.replace("{id}", projectId)}?page=${page}&size=${size}${benefitId ? `&benefitId=${benefitId}` : ""}${userName ? `&userName=${userName}` : ""}`);
  return res.data;
}

export const getProjectRevisit = async (projectId) => {
  const res = await fetchApi.get(`${API_URL.GET_REVISIT_EVENT_PROJECT.replace("{id}", projectId)}`);
  return res.data;
}

export const postProjectRevisitEvent = async (projectId, used, minPoint, maxPoint) => {
  const res = await fetchApi.post(API_URL.SAVE_REVISIT_EVENT_PROJECT, {
    projectId: projectId,
    used: used,
    minPoint: Number(minPoint),
    maxPoint: Number(maxPoint)
  });
  return res.data;
}

export const getMetaTag = async (projectId) => {
  const res = await fetchApi.get(`${API_URL.GET_META_TAG_PROJECT.replace("{id}", projectId)}`);
  return res.data;
}

export const postMetaTagSave = async (id, name, imageUrl, description) => {
  const res = await fetchApi.post(API_URL.META_TAG_PROJECT, {
    id: id,
    name: name,
    imageUrl: imageUrl,
    description: description
  });
  return res.data;
}

export const postCheckNewUser = async (projectId, used) => {
  const res = await fetchApi.post(API_URL.CHECK_NEW_USER_PROJECT, {
    id: projectId,
    used: used
  });

  return res.data;
}

// 참여 완료 후 이동(2026-10-27). 응답/요청 모양은 백엔드 Project.ProjectSettings.CompleteRedirect 와 같다.
export const getCompleteRedirect = async (projectId) => {
  const res = await fetchApi.get(`${API_URL.GET_COMPLETE_REDIRECT_PROJECT.replace("{id}", projectId)}`);
  return res.data;
}

// 검증 실패(허용 도메인 없음·도메인 불일치·대기 시간 범위 등)는 400 으로 오고 fetch.js 가 사유를 alert 한 뒤 Promise 를 멈춘다.
export const postCompleteRedirectSave = async (projectId, settings) => {
  const res = await fetchApi.post(API_URL.COMPLETE_REDIRECT_PROJECT, {
    projectId: projectId,
    settings: settings
  });
  return res.data;
}

export const getSurvey = async (projectId) => {
  const res = await fetchApi.get(`${API_URL.GET_SURVEY_PROJECT.replace("{id}", projectId)}`);
  return res.data;
}

export const postSurveyUsedSave = async (projectId, used) => {
  const res = await fetchApi.post(API_URL.SURVEY_USED_PROJECT, {
    projectId: projectId,
    used: used
  });

  return res.data;
}

export const postSurveyQuestionsSave = async (projectId, title, description, questions) => {
  const res = await fetchApi.post(API_URL.SURVEY_QUESTIONS_PROJECT, {
    projectId: projectId,
    title: title,
    description: description,
    questions: questions
  });

  return res.data;
}

export const getSurveyStatistics = async (projectId) => {
  const res = await fetchApi.get(`${API_URL.SURVEY_STATISTICS.replace("{id}", projectId)}`);
  return res.data;
}

export const getSurveyResponses = async (projectId) => {
  const res = await fetchApi.get(API_URL.SURVEY_RESPONSES.replace("{id}", projectId));
  return res?.data;
}
